import React from 'react'
import Navbar from "./ReportsNavbar/Navbar"
import Graphs from './Graphs'
const Index = () => {
    return (
        <div>
            <Navbar />
            <Graphs />
        </div>
    )
}

export default Index
